export default __webpack_public_path__ + "static/iPhonebg-while-3fc4a25f7ad1124f55334f7d3edc2c3f.png";